import datePicker from './date_picker';
import { venueSuggester } from './suggesters';
import { passwordFieldset} from './passwords';
import { revealer, appendsFields, removesFields, subordinateField, enactRemoteLink } from './helpers';
import { pjaxFetch, fadeOut, replaceWith, containEvent } from './utilities';
// TODO make extensible so I don't have to do this
import { oneliner } from '../lmdr/serials';
import { log } from './logging';
import { activate } from "./activate";
import {refresh} from "./refreshers";

class Popup {
  constructor(el) {
    this._link = el;
    const href = el.href || el.dataset.popup;
    log("🌼 popup click", href);
    this._iteration = 0;
    if (href) {
      this.prepareElements();
      this.get(href);
    }
  }

  /* PREPARE MODAL */

  prepareElements() {
    document.querySelectorAll('div.mask').forEach((el) => el.remove());
    this._mask = document.createElement('div');
    this._mask.classList.add("mask");
    this._container = document.createElement('div');
    this._container.classList.add("popup");
    this._container.addEventListener('submit', this.submitForm.bind(this));
    this._mask.addEventListener('click', this.otherClick.bind(this));
    document.body.appendChild(this._mask);
    this._mask.appendChild(this._container);
  }

  /* CATCH EVENTS */

  // capture and ajaxify any remote-form submits within the popup
  submitForm(e) {
    containEvent(e);
    const form = e.target;
    if (form && form.action) {
      this.post(form.action, new FormData(form));
    }
  }

  // capture close-clicks
  otherClick(e) {
    if (e.target.matches('a.closer') || e.target.matches('a.cancel') || e.target.matches('div.mask')) {
      containEvent(e);
      this.hidePopup(e);
    }
  }

  /* FETCH AND DISPLAY HTML */

  get(href) {
    pjaxFetch(href).then(this.showResponse.bind(this));
  }

  post(href, formData) {
    pjaxFetch(href, {
      method: 'post',
      body: formData
    }).then(this.showResponse.bind(this));
  }

  showResponse(text) {
    this._container.innerHTML = text;
    if (this._iteration == 0 || this._container.querySelector('form')) {
      this.enableHelpers();
      this.showPopup();
      this._iteration += 1;
    } else {
      // if we are past the first step and no form is found in the response,
      // we take it that no work remains to do, and update the page
      // NB. response should always have a single outer element for insertion.
      this.updatePage(text);
    }
  }

  // add ui helpers to the displayed form
  // TODO wrap in a single helper method such that the list can be extended...
  enableHelpers() {
    activate(this._container);
    // this._container.querySelectorAll('a[data-action="popup"]').forEach((el) => {
    //   popupOnClick(el);
    // });
    // this._container.querySelectorAll('[data-role="datepicker"]').forEach((el) => {
    //   datePicker(el);
    // });
    // this._container.querySelectorAll('[data-role="venuepicker"]').forEach((el) => {
    //   venueSuggester(el);
    // });
    // this._container.querySelectorAll('[data-role="oneliner"]').forEach((el) => {
    //   oneliner(el);
    // });
    // this._container.querySelectorAll('fieldset[data-role="password"]').forEach((el) => {
    //   passwordFieldset(el);
    // });
    // this._container.querySelectorAll('[data-action="append_fields"]').forEach((el) => {
    //   appendsFields(el);
    // });
    // this._container.querySelectorAll('[data-action="remove_fields"]').forEach((el) => {
    //   removesFields(el);
    // });
    // this._container.querySelectorAll('[data-dependent]').forEach((el) => {
    //   subordinateField(el);
    // });
    // this._container.querySelectorAll('[data-reveals]').forEach((el) => {
    //   revealer(el);
    // });
  }

  // after chain is complete, perform the page actions specified by the original link.
  updatePage(text) {
    const updated = enactRemoteLink(this._link, text);
    if (!updated) {
      const refresher = this._link.closest('[data-refreshing]');
      if (refresher) {
        refresh(refresher);
      }
    }
    this.reset();
  }

  /* CONTROL MODAL */

  showPopup() {
    this._mask.classList.add('up');
    this._container.classList.add('up');
  }

  hidePopup() {
    this._mask.classList.remove('up');
    this._container.classList.remove('up');
  }

  focus() {
    const af = this._container.querySelector('[autofocus]')
    if (af) af.focus()
  }

  reset() {
    if (this._mask) this._mask.remove();
    this._iteration = 0;
  }
}

function popupOnClick(el) {
  el.addEventListener('click', (e) => {
    containEvent(e);
    new Popup(el);
  });
}

export default popupOnClick; 